import { toast } from "sonner";

export const canShareFiles = (files) => {
  try { return !!(navigator.share && navigator.canShare && navigator.canShare({ files })); } catch { return false; }
};

// Native share sheet when available; otherwise copy the link (or download the file) and say so.
export async function shareContent({ title, text, url, files, copiedMsg = "Link copied", fallbackDownload }) {
  const payload = { title, text };
  if (url) payload.url = url;
  if (files?.length && canShareFiles(files)) payload.files = files;
  if (navigator.share && (payload.url || payload.files)) {
    try { await navigator.share(payload); return "shared"; } catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  if (files?.length && fallbackDownload) { await fallbackDownload(); return "downloaded"; }
  if (url) {
    try { await navigator.clipboard.writeText(url); toast.success(copiedMsg, { description: url }); return "copied"; }
    catch { window.prompt(copiedMsg, url); return "prompted"; }
  }
  return "unsupported";
}
